<template>
  <IconSlideButton :label icon="times" severity="danger" :colorClass="cancelColorClass"></IconSlideButton>
</template>

<script setup lang="ts">
interface Props {
  label?: string;
}
const props = withDefaults(defineProps<Props>(), {
  label: "Cancel",
});

const cancelColorClass = ref<string>("bg-danger-500/20! hover:shadow-danger-500/50! hover:bg-danger-500!");
</script>
